import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
          Our academic program is designed to ensure that students explore a
          variety of areas to establish critical thinking and communication
          skills and engage in hands-on, active learning.
        </p>
      </Container>
    </div>
  );
};

export default Message;
